// extracted by mini-css-extract-plugin
module.exports = {"ButtonText":"ButtonText_ButtonText__2oFUo"};